import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import { addSuccessMessage } from "../SnackBar";

export const USERS_DELETE_REQUEST = 'DELETE_USERS_REQUEST';
export const USERS_DELETE_FAILURE = 'DELETE_USERS_FAILURE';
export const USERS_DELETE_SUCCESS = 'DELETE_USERS_SUCCESS';

export const deleteUser = (id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(deleteUserRequest());
        return axios(apiRequestOptions(apiPath.USER.DELETE, null, { params }))
            .then(transformHttpResponse)
            .then(() => {
                dispatch(addSuccessMessage('User successfully deleted'));
                dispatch(deleteUserSuccess(id));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(deleteUserFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const deleteUserRequest = () => ({ type: USERS_DELETE_REQUEST });

const deleteUserFailure = (error) => ({ type: USERS_DELETE_FAILURE, error });

const deleteUserSuccess = (id) => ({ type: USERS_DELETE_SUCCESS, id });
